import { EnvironmentProviders, Provider } from '@angular/core';
import {
  CompositePropagatorModule,
  NoopSpanExporterService,
  OpenTelemetryConfig,
  OTEL_CONFIG,
  OTEL_EXPORTER,
  OTEL_INSTRUMENTATION_PLUGINS,
  OtelcolExporterService,
  OtelWebTracerModule,
} from '@jufab/opentelemetry-angular-interceptor';
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { UserInteractionInstrumentation } from '@opentelemetry/instrumentation-user-interaction';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';

export interface TelemetryConfig extends OpenTelemetryConfig {
  enabled: boolean;
}

export function opentelemetryModules(config: TelemetryConfig) {
  return [
    //Insert module OpenTelemetryInterceptorModule with configuration, HttpClientModule is used for interceptor
    // OpenTelemetryInterceptorModule.forRoot(config),
    OtelWebTracerModule.forRoot(config),
    // ConsoleSpanExporterModule,
    //Insert OtelCol exporter module
    // OtelColExporterModule,
    //Insert propagator module
    CompositePropagatorModule,
  ];
}

export function opentelemetryProviders(
  config: TelemetryConfig,
): (Provider | EnvironmentProviders)[] {
  const ignoreUrls = [/firestore/];

  return [
    {
      provide: OTEL_INSTRUMENTATION_PLUGINS,
      useValue: [
        new XMLHttpRequestInstrumentation({
          ignoreUrls,
        }),
        new DocumentLoadInstrumentation(),
        new FetchInstrumentation({
          ignoreUrls,
        }),
        new UserInteractionInstrumentation({
          eventNames: ['play', 'submit'],
        }),
      ],
    },
    { provide: OTEL_CONFIG, useValue: config },
    {
      provide: OTEL_EXPORTER,
      useClass: config.enabled
        ? OtelcolExporterService
        : NoopSpanExporterService,
    },
  ];
}
